import React, {useState, useCallback} from 'react';

export const UseToggle = initial => {
    const [open, setOpen] = useState(initial);
    return [open, useCallback((newState) => {
        setOpen(status => typeof newState === "boolean" 
            ? newState 
            : !status
        )
    })];
};

export default UseToggle;